module.exports = __webpack_public_path__ + "img/fun_halloween.6cfd87d0.jpg";